<ion-modal [isOpen]="isOpen()" (didDismiss)="onDidDismiss()" cssClass="gojs-editor-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar class="px-3">
        <div slot="start" class="flex items-center">
          <ion-title class="font-primary pl-0 text-lg font-semibold">Edit Diagram</ion-title>
        </div>
        <div slot="end" class="flex items-center gap-2">
          <dojo-button fill="outline" size="s" (click)="cancel()">Cancel</dojo-button>
          <dojo-button size="s" (click)="save()">Save</dojo-button>
        </div>
      </ion-toolbar>
    </ion-header>

    <ion-content [scrollY]="false">
      <div class="editor-layout">
        <!-- Left: Palette & Settings -->
        <div class="left-panel">
          <div class="panel-section">
            <h4 class="panel-title">Drag to canvas</h4>
            <div #paletteDiv class="palette-div"></div>
          </div>

          <div class="panel-section auto-layout-toggle">
            <label class="toggle-label">Auto Layout</label>
            <ion-toggle [checked]="autoLayout()" (ionChange)="onAutoLayoutToggle(ionToggleChecked($event))" />
          </div>

          @if (autoLayout()) {
            <div class="panel-section">
              <dojo-single-select
                label="Layout"
                [formCtrl]="layoutCtrl"
                [options]="layoutOptions"
                optionLabel="label"
                optionValue="value"
                size="s"
                (selectionChange)="applyLayout($event)"
              />
            </div>
          }

          <div class="panel-section">
            <dojo-number-input
              label="Render Height (px)"
              [formCtrl]="heightCtrl"
              [min]="100"
              [max]="800"
              [step]="10"
              size="s"
            />
          </div>

          <div class="panel-section auto-layout-toggle">
            <label class="toggle-label">Show Background</label>
            <ion-toggle [checked]="showBackground()" (ionChange)="onShowBackgroundToggle(ionToggleChecked($event))" />
          </div>
        </div>

        <!-- Center: Diagram Canvas -->
        <div class="canvas-panel">
          <div #editorDiv class="editor-div" [class.show-bg]="showBackground()"></div>
        </div>

        <!-- Right: Properties Panel -->
        <div class="right-panel">
          @if (selectedNodeData(); as nodeData) {
            <dojo-gojs-node-properties-panel
              [nodeData]="nodeData"
              [parsedNodeIcon]="parsedNodeIcon()"
              [showIconPicker]="showIconPicker()"
              [nodeTextCtrl]="nodeTextCtrl"
              [nodeShapeCtrl]="nodeShapeCtrl"
              [nodeColorThemeCtrl]="nodeColorThemeCtrl"
              [nodeFontSizeCtrl]="nodeFontSizeCtrl"
              [nodeFontWeightCtrl]="nodeFontWeightCtrl"
              [nodeWidthCtrl]="nodeWidthCtrl"
              [nodeHeightCtrl]="nodeHeightCtrl"
              [shapeOptions]="shapeOptions"
              [colorThemeOptions]="colorThemeOptions"
              [fontWeightOptions]="fontWeightOptions"
              (sendToBack)="sendToBack()"
              (bringToFront)="bringToFront()"
              (textInput)="onTextInput()"
              (mathToggle)="onMathToggle($event)"
              (borderToggle)="onBorderToggle($event)"
              (colorThemeChange)="onColorThemeChange($event)"
              (iconSelected)="onNodeIconSelected($event)"
              (iconCleared)="clearNodeIcon()"
              (iconPickerToggle)="showIconPicker.set($event)"
              (nodeShapeChange)="updateNodeProp('shape', $event)"
              (fontSizeChange)="updateNodeProp('font_size', $event)"
              (fontWeightChange)="updateNodeProp('font_weight', $event)"
              (sizeChange)="onSizeChange()"
            />
          } @else {
            @if (selectedLinkData(); as linkData) {
              <dojo-gojs-link-properties-panel
                [linkData]="linkData"
                [linkColorCtrl]="linkColorCtrl"
                [linkArrowCtrl]="linkArrowCtrl"
                [linkWidthCtrl]="linkWidthCtrl"
                [linkColorOptions]="linkColorOptions"
                [arrowOptions]="arrowOptions"
                (linkColorChange)="onLinkColorChange($event)"
                (arrowChange)="updateLinkProp('to_arrow', $event)"
                (widthChange)="updateLinkProp('width', $event)"
              />
            } @else {
              <div class="empty-state">
                <div class="empty-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                    <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                    <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                    <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                  </svg>
                </div>
                <p class="empty-title">No selection</p>
                <p class="empty-hint">Click a node or link on the canvas to edit its properties</p>
                <p class="empty-hint">Drag shapes from the left panel to add nodes</p>
                <p class="empty-hint">Drag from one node to another to create links</p>
              </div>
            }
          }
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
